module.exports = __webpack_public_path__ + "static/media/EllenRipley.42241f54.png";